import React, { useEffect } from 'react';
import GalleryVideoWidget from '../components/home/GalleryVideoWidget.tsx';
import { useApp } from '../context/AppContext.tsx';

export default function GalleryCatalog() {
  const { settings } = useApp();
  const gallerySec = settings?.sections?.find((s) => s.type === 'gallery_video');
  const pageTitle = gallerySec?.title || 'Galeri Foto & Video';
  const pageSubtitle = gallerySec?.subtitle || 'Dokumentasi video dan arsip kegiatan.';

  useEffect(() => {
    const customTab = settings?.pageTabTitles?.gallery?.trim();
    if (customTab) {
      document.title = customTab;
    } else {
      const suffix = settings?.pageTabTitles?.titleSuffix !== undefined ? settings.pageTabTitles.titleSuffix : ` | ${settings?.siteName || ''}`;
      document.title = `${pageTitle}${suffix}`;
    }
  }, [pageTitle, settings?.siteName, settings?.pageTabTitles?.gallery, settings?.pageTabTitles?.titleSuffix]);

  return (
    <div id="gallery-catalog-page" className="py-6">
      <GalleryVideoWidget
        badge={gallerySec?.badge || 'VISUAL DOCUMENTATION & MEDIA'}
        title={pageTitle}
        subtitle={pageSubtitle}
        limit={8}
        isPageMode={true}
      />
    </div>
  );
}
